import type { TypeSpec } from '../shared/contracts.js';
/** Editing a modeled type invalidates its verbatim SQL spelling, not its retained import evidence. */
export function editFieldType(current: TypeSpec | undefined, changes: Partial<TypeSpec>): TypeSpec {
  const next: TypeSpec = { ...current, name: current?.name ?? '', ...changes };
  delete next.raw;
  if (changes.name !== undefined && changes.name !== current?.name) {
    if (!/char|binary|bit/i.test(next.name)) delete next.length;
    if (!/decimal|numeric|number|float|real|double/i.test(next.name)) { delete next.precision; delete next.scale; }
  }
  for (const key of ['length','precision','scale'] as const) if(next[key] === undefined) delete next[key];
  return next;
}
